import { apiFetch } from "./apiClient";

const BASE = "/api/services/task/service-tasks";

export async function getServiceTasks() {
  const res = await apiFetch(BASE);
  if (!res.ok) throw new Error("Failed to fetch service tasks");
  return res.json();
}

export async function createServiceTask(payload) {
  const res = await apiFetch(BASE, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to create service task");
  }
  return res.json();
}

export async function updateServiceTask(taskId, payload) {
  const res = await apiFetch(`${BASE}/${taskId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update service task");
  }
  return res.json();
}

export async function getDeviceManufacturerModels() {
  const res = await apiFetch(`/api/services/task/device-manufacturer-models`);
  if (!res.ok) throw new Error("Failed to fetch device manufacturer/models");
  return res.json();
}

export async function getTaskDeviceBlacklist(taskId) {
  const res = await apiFetch(`${BASE}/${taskId}/device-blacklist`);
  if (!res.ok) throw new Error("Failed to fetch task device blacklist");
  return res.json();
}

export async function getAllTaskDeviceBlacklist() {
  const res = await apiFetch(`/api/services/task/service-task-device-blacklist`);
  if (!res.ok) throw new Error("Failed to fetch task device blacklist entries");
  return res.json();
}

export async function addTaskDeviceBlacklistEntry(taskId, payload) {
  const res = await apiFetch(`${BASE}/${taskId}/device-blacklist`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update task device compatibility");
  }
  return res.json();
}

export async function removeTaskDeviceBlacklistEntry(taskId, payload) {
  const res = await apiFetch(`${BASE}/${taskId}/device-blacklist`, {
    method: "DELETE",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update task device compatibility");
  }
  return res.json();
}
